'use strict';

export default angular
  .module('maestro.filters.filterAndHideItem', [])

  .filter('filterAndHideItem',
    //If the DOM contains image tag, Please use this filter
    //not reutrn new array, So the Page DOM not refresh again
    function($filter) {
      return function(array, expression, comparator) {
        if (!array) {
          return array;
        }
        let newArray = $filter('filter')(array, expression, comparator);
        array.forEach(function(itemI) {
          let flag = false;
          for (let i = 0; i < newArray.length; i++) {
            let itemJ = newArray[i];
            if (itemI == itemJ) {
              flag = true;
              break;
            }
          }
          itemI.displayDom = flag;
        });
        return array;
      };
    })

  .name;
